import React from "react";
import Select from "../../shared/Select";
const SelectReferralInitiatedBy = ({ value }) => {
  return (
    <Select label="Initiated By" name="referral_initiated_by" value={value} required={true}>
      <option value={""}> -- </option>
      <option value={"PCP"}> PCP </option>
      <option value={"Patient"}> Patient</option>
      <option value={"Specialist"}> Specialist </option>
      <option value={"Unknown"}> Unknown </option>
    </Select>
  );
};
export default SelectReferralInitiatedBy;
